
declare module 'axios' {
  export interface AxiosRequestConfig {
  }

  export interface AxiosResponse {
    isOk: boolean
  }
}

axios.interceptors.request.use((config) => {
  config.paramsSerializer = {
    indexes: null,
  }
  return config
})

axios.interceptors.response.use(
  (resp) => {
    const code: number = resp.data?.code

    const okCodes = [200]
    resp.isOk = okCodes.includes(code)

    if (!resp.isOk) {
      if (code === 401) {
        if (window.$message) {
          $message.error('登录已过期，请重新登录')
        }
      } else {
        if (window.$message) {
          const msg = resp.data.msg || '系统错误'
          $message.error(msg)
        }
      }
    }

    return resp
  },
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    }

    return Promise.reject(error)
  },
)

axios.defaults.baseURL = '/api/v1'
if (import.meta.env.MODE !== 'development' && window.location.hostname.endsWith('chinauos.com')) {
  axios.defaults.baseURL = '/driver-api/v1'
}
console.info('axios.defaults.baseURL', axios.defaults.baseURL)
